import './Home.css';
import PropTypes from 'prop-types';
import ItemType from '../types/item';

import Thumbnail from './Thumbnail';
import { itemImages } from '../items';

function Home({ items }) {
  return (
    <div className="home-component">
      {items.map((item) => (
        <Thumbnail
          key={item.itemId}
          image={itemImages[item.imageId]}
          title={item.title}
          itemId={item.itemId}
        />
      ))}
    </div>
  );
}

Home.propTypes = {
  items: PropTypes.arrayOf(ItemType).isRequired,
};

export default Home;
